export default __webpack_public_path__ + "static/media/emailSended.5323f02d.svg";